module.exports = __webpack_public_path__ + "fi.3733753bbd18fcd8c82e.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/fi.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/fi.svg
// module chunks = styles